import styled from 'styled-components';

export const Container = styled.div`
  display: flex;

  padding: ${({ theme }) => `${theme.spacing(2)}`};

  overflow: auto;
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  height: 2.6rem;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  white-space: nowrap;

  color: ${({ theme }) => theme.palette.text.primary};
`;
